import { Base } from '@studiometa/js-toolkit';

/**
 * CarrouselReassurence.
 *
 */
export default class CarrouselReassurence extends Base {
  index = 0;

  static config = {
    name: 'CarrouselReassurence',
    refs: ['nav[]', 'wrapper'],
  };

  /**
   *
   */
  mounted() {
    this.currentNav = this.$refs.nav[0];
    this.navLength = this.$refs.nav.length;
    this.initInterval();
  }

  /**
   * When entering component -> stop animations
   */
  onMouseenter() {
    clearInterval(this.intervalId);
  }

  /**
   * When leaving component
   */
  onMouseleave() {
    this.initInterval();
  }

  /**
   *
   */
  initInterval() {
    this.intervalId = setInterval(() => {
      this.index += 1;
      this.switchState();
    }, 2000);
  }

  /**
   * Change slide
   * @param {object} props Props
   * @param {object} props.index current index.
   * @returns {void}
   */
  onNavClick({ index }) {
    this.index = index;
    this.switchState();
  }

  /**
   * Slide animations + dots opacity
   * @returns {void}
   */
  switchState() {
    if (this.index >= this.navLength) {
      this.index = 0;
    }

    this.currentNav.classList.add('opacity-20');
    this.currentNav = this.$refs.nav[this.index];
    this.$refs.wrapper.style.transform = `translateX(-${100 * this.index}%)`;
    this.currentNav.classList.remove('opacity-20');
  }
}
